module.exports = __webpack_public_path__ + "img/image 008.1b6746e5.png";